<template>
    <div class="user">
        <div class="user__inner">
            <div class="user__item user__item_name">
                {{user_data.name}}
            </div>

            <div class="user__item">
                <p class="user__mob-label">К оплате: </p>
                <input
                    v-model="toPay"
                    :readonly="role == 'user'"
                    @blur="editToPay"
                    @input="handleToPayInput"
                    class="user__input">
                <span class="user__currency">₽</span>
            </div>

            <div class="user__item">
                <p class="user__mob-label">Долг: </p>
                <input
                    v-model="debt"
                    :readonly="role == 'user'"
                    @blur="editDebt"
                    @input="handleDebtInput"
                    type="number"
                    class="user__input">
                <span class="user__currency">₽</span>
            </div>

            <div class="user__item user__item_file user-file">
                 <p class="user__mob-label user__mob-label_file">Плат. счет: </p>

                <div 
                    v-if="role == 'user' && !user_data.paymentFile"
                    class="user-file__empty">Отсутствует</div>

                <label 
                    v-if="role == 'ADMIN' && !user_data.paymentFile"
                    :for="user_data.id" class="user__label">{{userFile ? userFile.name : 'Добавить'}}</label>
                <input 
                    @change="handleUserFileUpload" 
                    :id="user_data.id" 
                    type="file" 
                    ref="userFile"
                    class="user__file">

                <button 
                    v-if="role == 'ADMIN' && userFile"
                    type="button"
                    @click="submitFile"
                    class="user-file__submit">{{isLoading ? 'Загрузка...' : 'Добавить'}}</button>

                <div 
                    v-if="user_data.paymentFile"
                    class="user-file__controlls user-file-controlls">
                    <button 
                        @click="showFile(user_data.paymentFile)"
                        class="user-file-controlls__show"
                        type="button"></button>

                    <button 
                        @click="downloadFile(user_data.paymentFile)"
                        class="user-file-controlls__download"
                        type="button"></button>

                    <button 
                        v-if="role == 'ADMIN'"
                        @click="deleteFile(user_data.paymentFile, user_data.id)"
                        class="user-file-controlls__delete"
                        type="button"></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
    data(){
        return {
            toPay: 0,
            debt: 0,
            role: "",
            userFile: "",
            isLoading: false
        }
    },
    props: {
        user_data: {
            type: Object,
            default(){
                return{

                }
            }
        }
    },
    methods: {
        getRole(){
            this.role = localStorage.getItem('role')
        },
        handleToPayInput(event) {
            let value = event.target.value

            // Оставляем только цифры и точку
            value = value.replace(/[^0-9.]/g, '')

            // Удаляем все точки кроме первой
            const parts = value.split('.')
            if (parts.length > 2) {
                value = parts[0] + '.' + parts.slice(1).join('')
            }

            let [integer, decimal] = value.split('.')

            // Убираем ведущие нули в целой части
            if (integer) {
                integer = integer.replace(/^0+(?=\d)/, '')
            }

            // Ограничиваем до 2 знаков после точки
            if (decimal !== undefined) {
                decimal = decimal.slice(0, 2)
                value = integer + '.' + decimal
            } else {
                value = integer
            }

            this.toPay = value
        },
        handleDebtInput(event) {
            let value = event.target.value

            // Оставляем только цифры и точку
            value = value.replace(/[^0-9.]/g, '')

            // Удаляем все точки кроме первой
            const parts = value.split('.')
            if (parts.length > 2) {
                value = parts[0] + '.' + parts.slice(1).join('')
            }

            let [integer, decimal] = value.split('.')

            // Убираем ведущие нули в целой части
            if (integer) {
                integer = integer.replace(/^0+(?=\d)/, '')
            }

            // Ограничиваем до 2 знаков после точки
            if (decimal !== undefined) {
                decimal = decimal.slice(0, 2)
                value = integer + '.' + decimal
            } else {
                value = integer
            }

            this.debt = value
        },
        handleUserFileUpload(){
            this.userFile = this.$refs.userFile.files[0];            
        },
        submitFile(){
            this.isLoading = true
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            const formData = new FormData()
            formData.append('url', this.userFile)
            axios({
                method: 'PUT',
                url: 'https://lk-berry1.ru:3000/api/user/uploadfile',
                headers: { Authorization: `Bearer ${cookie[1]}`, "Content-Type": "multipart/form-data" },
                data: formData,
                params:{
                    id: this.user_data.id
                }
            }).then(()=>{
                location.reload()
            })
        },
        showFile(orderUrl){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            axios.get(`https://lk-berry1.ru:3000/api/user/showFile`,{
                headers: {Authorization: `Bearer ${cookie[1]}`},
                responseType: 'blob',
                params:{
                    url: orderUrl
                }
            }).then((res)=>{
                let url = URL.createObjectURL(res.data)
                let link = document.createElement('a')
                link.href = url
                link.target = "_blank"
                window.open(link)
            })
        },
        downloadFile(orderUrl){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            return axios({
                method: "GET",
                url: 'https://lk-berry1.ru:3000/api/user/downloadFile',
                headers: {Authorization: `Bearer ${cookie[1]}`},
                responseType: 'blob',
                params:{
                    url: orderUrl
                }
            }).then((res)=>{
                fileDownload(res.data, orderUrl)
            })
        },
        deleteFile(fileUrl, id){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            let removeFile = confirm("Вы уверены?");
            if(removeFile){
                axios({
                    method: 'DELETE',
                    url: `https://lk-berry1.ru:3000/api/user/deleteFile`,
                    headers: {Authorization: `Bearer ${cookie[1]}`},
                    params: {
                        url: fileUrl,
                        id: id
                    }
                }).then(()=>{
                    location.reload()
                })
            }
        },
        editToPay(){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            let role = localStorage.getItem('role')

            if(role == 'ADMIN'){
                axios({
                    method: 'PUT',
                    url: `https://lk-berry1.ru:3000/api/user/editToPay`,
                    headers: {Authorization: `Bearer ${cookie[1]}`},
                    params: {
                        toPayValue: this.toPay,
                        userId: this.user_data.id
                    }
                }).then(()=>{
                    this.$emit("showNotification")
                })      
            }      
        },
        editDebt(){ 
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            let role = localStorage.getItem('role')

            if(role == 'ADMIN'){
                axios({
                    method: 'PUT',
                    url: `https://lk-berry1.ru:3000/api/user/editDebt`,
                    headers: {Authorization: `Bearer ${cookie[1]}`},
                    params: {
                        debtValue: this.debt,
                        userId: this.user_data.id
                    }
                }).then(()=>{
                    this.$emit("showNotification")
                }) 
            }                           
        },
    },
    mounted(){
        this.getRole()
        this.toPay = this.user_data.toPay
        this.debt = this.user_data.debt        
    }
}
</script>

<style scoped>
    .user__inner{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        width: 100%;
        border: 1px solid #000;
    }
    .user__item{
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        border-right: 1px solid #000;        
        padding: 10px;
        max-width: 141px;
        /* text-overflow: ellipsis; */
    }
    .user__item_name{
        overflow-x: scroll;
    }
    .user__item_name::-webkit-scrollbar {
        width: 2px;      
        height: 4px;  
    }
    .user__item_name::-webkit-scrollbar-track {
        background: #E7E1E3; 
        border-radius: 50px;       
    }
    .user__item::-webkit-scrollbar-thumb {
        background-color: #878787;    
        border-radius: 20px;       
    }
    .user__item:last-child{
        border-right: none;
    }
    .user__input{
        text-align: center;
        width: 100%;
        border: none;
        outline: none;
        background: transparent;
        padding-left: 11px;
    }
    .user__file{
        display: none;
    }
    .user__item_file{
        display: flex;
        flex-direction: column;
    }
    .user-file__submit{
        margin-top: 10px;
        border: 1px solid #000;
        padding: 5px;
        width: 100%;
    }
    .user-file__controlls{
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .user-file-controlls__show{
        height: 30px;
        width: 30px;
        background: url(../images/eye.svg) no-repeat;
        background-size: cover;
    }
    .user-file-controlls__download{
        height: 30px;
        width: 30px;
        background: url(../images/download.svg) no-repeat;
        background-size: cover;
    }
    .user-file-controlls__delete{
        height: 30px;
        width: 30px;
        background: url(../images/delete-ico.webp) no-repeat;
        background-size: cover;
    }
    .user__mob-label{
        display: none;
    }
    @media (max-width: 600px) {        
        .user__mob-label{
            display: block;
            width: 33%;
            text-align: left;
        }
        .user__input{
            width: 33%;
            padding-left: 0;
        }
        .user__currency{
            width: 33%;
            text-align: right;
        }
        .user__inner{
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            width: 100%;
        }
        .user__item{
            justify-content: space-between;
            border-right: none;
            max-width: none;
        }
        .user__mob-label_file{
            text-align: center;
            margin-bottom: 10px;
            width: 100%;
            border-top: 1px solid #000;
            padding-top: 5px;
        }
        .user__item_name{
            overflow: initial;
            border-bottom: 1px solid #000;
            display: block;
            
        }
    }
</style>